import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogBaseViewComponent, Field, FormBase, Required, Scope } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { WebsiteBlockDisplayItem, WebsitePageDisplayItem } from '@sb/library/data-models';
import { FormFieldModule } from '@sb/library/form-field';
import { LayoutModule } from '@sb/library/layout';
import { SubmissionBarModule } from '@sb/library/submission-bar';

export class WebsiteBlockCloneBlockScope extends Scope {
    CloneBlockToPage = Field<(block: WebsiteBlockDisplayItem, page: WebsitePageDisplayItem) => void>();
    pages = Field<WebsitePageDisplayItem[]>();
    currentPageID = Field<string>();
}

export class WebsiteBlockCloneBlockForm extends FormBase {
    Page = Required(WebsitePageDisplayItem);
}

@Component({
    selector: 'lib-clone-block-dialog',
    templateUrl: './clone-block-dialog.component.html',
    styleUrls: ['./clone-block-dialog.component.scss'],
    standalone: true,
    imports: [CommonModule, LayoutModule, SubmissionBarModule, ButtonModule, FormFieldModule, ReactiveFormsModule]
})
export class CloneBlockDialogComponent extends DialogBaseViewComponent<WebsiteBlockDisplayItem> {
    Scope = this.SetScope({
        Requires: WebsiteBlockCloneBlockScope
    });

    readonly form = WebsiteBlockCloneBlockForm.Create(true);

    private _pages: WebsitePageDisplayItem[] = [];

    constructor() {
        super();
        this._pages = this.FlattenPages(this.Scope.pages);
        this.form.controls.Page.setValue(this.currentPage);
    }

    override PrimaryAction(): void {
        super.PrimaryAction();
        this.Scope.CloneBlockToPage(this.data, this.form.controls.Page.value!);
        this.DismissAction();
        
    }

    private FlattenPages(pages: WebsitePageDisplayItem[]): WebsitePageDisplayItem[] {
        return pages.flatMap(p => [p, ...this.FlattenPages(p.ChildPages)]);
    }

    get pages(): WebsitePageDisplayItem[] {
        return this._pages;
    }

    get currentPage(): WebsitePageDisplayItem | null {
        return this.pages.find(p => p.ID === this.Scope.currentPageID) ?? null;
    }

}
